import React from 'react'
import { string, array, number, object } from 'prop-types'
import Case from 'case'
import { FormattedMessage } from 'react-intl'
import { urlWithTrack } from '../../helpers/common'
import { sendClickEventToInsights } from '../../utils/insights'
import { NUMERAL, EMPTY_ARRAY, EMPTY_OBJECT, ALL } from '../../utils/constants'
import AdLink from '../ui/ad-link/AdLink'
import Image from '../ui/image/Image'
import Insights from './Insights'
import { widgetMessages as messages } from './messages'

const positions = ['a', 'b', 'c', 'd']

const Widget = ({ type = '', query = '', items = EMPTY_ARRAY, url = NUMERAL, item = EMPTY_OBJECT, index }) => {
  const handleLinkClick = () => {
    sendClickEventToInsights(
      'search-all-widget-' + type,
      decodeURI(query),
      type + '/' + item.document_id,
      positions[index]
    )
  }
  const trackedUrl = urlWithTrack(url, ALL)

  const itemsShorted = items.slice(0, 4)

  return (
    <div className='widget__container'>
      {/* title */}
      <div className='widget__title'>
        <h3>
          <FormattedMessage {...messages['resultsFor' + Case.pascal(type)]} />
        </h3>
      </div>

      {/* more */}
      <div className='widget__anchor'>
        <AdLink href={trackedUrl}>
          <FormattedMessage {...messages[type + 'Search']} />
          {` >>`}
        </AdLink>
      </div>

      {/* items slider */}
      <div className='widget-items'>
        {itemsShorted.map((item, index) => (
          <div className='widget-item__wrapper' key={index}>
            <Insights
              category={'search-all-widget-' + type}
              label={decodeURI(query)}
              value={type + '/' + item.document_id}
              version={positions[index]}
            >
              <AdLink href={urlWithTrack(item.url, ALL)} onClick={handleLinkClick}>
                <Image className='widget-item__img' src={item.featured_images.url_medium} data-object-fit='cover' />
                <h5 className='widget-item__title'>{item.title}</h5>
              </AdLink>
            </Insights>
          </div>
        ))}
      </div>
    </div>
  )
}

Widget.propTypes = {
  type: string,
  query: string,
  items: array,
  url: string,
  item: object,
  index: number
}

export default React.memo(Widget)
